import type { SliderImage } from './microComponents/ImageCarousel';

import ExpandIcon from '../../../../../public/assets/images/icons/ExpandIcon';
import IconButton from '../../../common/IconButton';
import ImageCarousel from './microComponents/ImageCarousel';
import styles from '../styles/Slider.module.scss';
import { useState, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import ImageSliderModal from './microComponents/ImageSliderModal';
import themeProperties from '../../../../theme/themeProperties';
import { clsx } from 'clsx';

interface ImageSliderProps {
  images: SliderImage[];
  type: 'coordinate' | 'project';
  isMobile: boolean;
  imageSize: 'medium' | 'large';
  allowFullView?: boolean;
}

const ImageSlider = ({
  images,
  imageSize,
  type,
  isMobile,
  allowFullView = true,
}: ImageSliderProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const t = useTranslations('ProjectDetails');

  // Filter out images with empty or missing image property
  const validImages = useMemo(() => {
    return images.filter((image) => image?.image && image.image.trim() !== '');
  }, [images]);

  // Don't render if no valid images
  if (validImages.length === 0) {
    return null;
  }

  return (
    <>
      {!isModalOpen && (
        <div
          className={clsx(
            'image-slider-container',
            styles.imageSliderContainer
          )}
        >
          {allowFullView && (
            <IconButton
              label={t('expandImages')}
              onClick={() => setIsModalOpen(true)}
            >
              <ExpandIcon color={themeProperties.designSystem.colors.white} />
            </IconButton>
          )}
          <ImageCarousel
            images={validImages}
            type={type}
            imageSize={imageSize}
            imageHeight={192}
            isMobile={isMobile}
            isModalOpen={false}
            mode="auto"
          />
        </div>
      )}
      {allowFullView && (
        <ImageSliderModal
          currentIndex={currentIndex}
          images={validImages}
          setCurrentIndex={setCurrentIndex}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          isMobile={isMobile}
          type={type}
        />
      )}
    </>
  );
};

export default ImageSlider;
